import { RegisterOptions } from "react-hook-form";

type NicknameFieldProps = {
  register: (ref: string, options: RegisterOptions) => any;
  errors: Record<string, any>;
};

export const NicknameField: React.FC<NicknameFieldProps> = ({ register, errors }) => (
  <div className="field">
    <label>
      <span className="label">ニックネーム</span>
      <input
        type="text"
        placeholder="田中太郎"
        {...register("nickname", { required: true, maxLength: 15 })}
        data-test="input-nickname"
      />
      {errors.nickname && (
        <span className="sub red">
          {errors.nickname.type === "maxLength"
            ? "ニックネームは15文字以内で入力ください"
            : "ニックネームを入力してください"}
          <br />
        </span>
      )}
      <span className="sub">15文字まで</span>
    </label>
  </div>
);
